// extracted by mini-css-extract-plugin
export default {"card":"WZ-z","carouselContainer":"XZ-z","carouselContent":"YZ-z"};